export default "__VITE_ASSET__44e66855__"